<template>
  <div>
    <div v-if="isNei" class="goback" @click="toBack">
      <img src="../assets/img/goback_white.png"/>
    </div>
    <div :class="page=='home'?isBackgroundShow?'homeIndexBg':isBlack ? 'homeIndexBg':'homeIndex':'top'" v-else>
      <div class="header">
        <div class="listLogo" @click="toShowMenu">
          <img src="../assets/img/list.png" v-if="isShowMobileMenu" class="list"/>
          <img src="../assets/img/close.png" v-else class="close"/>
        </div>
        <div class="homeTitle">
          {{ homeTitle }}
        </div>
        <div class="logo" @click="toHome">
          <img src="../assets/img/logo.png"/>
        </div>
        <div class="menu">
          <div class="menu_list">
            <ul>
              <li :class="isActive ? 'active' : 'menu'" @click="toHome">首页</li>
              <li v-for="(menu, index) in menuList" :key="index" :class="currentMenuIndex == index ? 'active' : 'menu'"
                  @mouseenter="mouseenterFirstMenu(menu, index)" @click="clickFirstMenu(menu)">
                {{ menu.name.length > 10 ? menu.name.substr(0, 10) + '...' : menu.name }}
              </li>
            </ul>
          </div>
          <div class="second_menu" v-if='currentMenuIndex != -1' @mouseleave="currentMenuIndex = -1">
            <ul>
              <li v-for="(menu, index) in secondMenuList" :key="index" @click="toDetail(menu, index)"
                  v-if="menu.type != 1">{{ menu.name.length > 10 ? menu.name.substr(0, 10) + '...' : menu.name }}
                <div class="threeMenu" v-if="menu.threeMenuList.length > 0">
                  <div v-for="(threeMenu, threeIndex) in menu.threeMenuList" :key="threeIndex" class="threeMenu_title"
                       @click.stop="toDetailInfo(menu, threeMenu)">{{ threeMenu.title }}
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="menu_mobile">
          <div class="menu_list" v-if="!isShowMobileMenu">
            <div @click="currentMenuIndex = -1" class="menu_item">
              <div class="firstmenu" @click="toIndex">
                <span>首页</span>
                <img src="../assets/img/open_mobile.png" v-if="currentMenuIndex !== -1" class="open_mobile">
                <img src="../assets/img/close_mobile.png" v-else class="close_mobile">
              </div>
            </div>
            <div v-for="(menu, index) in menuList" :key="index"
                 @click="mouseenterFirstMenu(menu, index)" class="menu_item">
              <div :class="currentMenuIndex == index ? 'active firstmenu' : 'firstmenu'">
                <span>{{ menu.name.length > 10 ? menu.name.substr(0, 10) + '...' : menu.name }}</span>
                <img src="../assets/img/open_mobile.png" v-if="currentMenuIndex !== index" class="open_mobile">
                <img src="../assets/img/close_mobile.png" v-else class="close_mobile" @click.stop="currentMenuIndex = -2">
              </div>
              <div class="second_menu" v-if='currentMenuIndex == index'>
                <li v-for="(menu, index) in secondMenuList" :key="index" @click="toDetail(menu, index)"
                    v-if="menu.type != 1">{{ menu.name.length > 10 ? menu.name.substr(0, 10) + '...' : menu.name }}
                </li>
              </div>
            </div>
          </div>
        </div>
        <div class="search_btn" @click="clickSearch">
          <img src="../assets/img/search.png"/>
        </div>
        <div class="search" v-if="inputSearch">
          <div class="search_i">
            <img src="../assets/img/small_search.png" v-if="searchKey == ''"/>
            <input placeholder="请输入搜索内容" @keyup.enter="toSearch()" v-model="searchKey"></input>
            <div class="searchBtn" @click="toSearch()">搜索</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {_toSearch} from "../api/services/InterfaceConfigurationPage";

export default {
  name: "headerTop",
  data() {
    return {
      inputSearch: false,
      currentMenuIndex: -1,
      menuList: [],
      secondMenuList: [],
      firstMenu: {}, //当前点击的一级菜单
      searchKey: '',
      searchDataList: [],
      isShowMobileMenu: true,
    }
  },
  created() {
    this.getMenulist()
  },
  props: {
    homeTitle: {
      type: String,
      default: ''
    },
    isBlack: {
      type: Boolean,
      default: false
    },
    page: {
      type: String,
      default: ''
    },
    isBackgroundShow: {
      type: Boolean,
      default: false
    },
    isNei: {
      type: Boolean,
      default: false
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // 点击搜索
    clickSearch() {
      // this.currentMenuIndex = -1;
      this.inputSearch = !this.inputSearch
    },
    // 返回上一页
    toBack() {
      this.$router.go(-1)
    },
    // 返回首页
    toIndex() {
      this.$router.push({path: '/'})
    },
    // 移动端点击菜单列表
    toShowMenu() {
      this.isShowMobileMenu = !this.isShowMobileMenu
    },
    // 搜索
    toSearch() {
      this.$router.push({
        path: '/searchList',
        query: {
          searchKey: this.searchKey
        }
      })
    },
    // 点击三级菜单
    toDetailInfo(menu, threeMenu) {
      this.$router.push({
        path: '/InformationDynamicsDetail',
        query: {id: threeMenu.id}
      })
    },
    // 点击二级菜单
    toDetail(menu, index) {
      // 1 文章模式、2产品模式、 3 新闻模式
      if (menu.pagemodel == 1) {
        // this.getJszcList(menu.id)
        this.$router.push({
          path: '/companyIntro',
          query: {parentid: menu.parentid, id: menu.id, grade: menu.grade, picpath: menu.picpath}
        })
      }
      if (menu.pagemodel == 2) {
        this.$router.push({
          path: '/productCenter',
          query: {parentid: menu.parentid, id: menu.id, grade: menu.grade, picpath: menu.picpath}
        })
      }
      if (menu.pagemodel == 3) {
        this.$router.push({
          path: '/InformationDynamics',
          query: {parentid: menu.parentid, id: menu.id, grade: menu.grade, picpath: menu.picpath}
        })
      }
    },
    // 获取技术支持列表
    getJszcList(id) {
      var params = {
        secondlevelid: id,
        pagesize: 5,
        pageindex: 1
      }
      this.$API.InterfaceConfigurationPage._getArticleList({
        params
      }).then(res => {
        if (res.success) {
          this.$router.push({
            path: '/InformationDynamicsDetail',
            query: {
              id: res.data[0].id
            }
          })
        } else {
          this.$Message.info('系统错误')
        }
      }).catch(err => {
        console.log('获取失败===', err);
      });
    },
    // 点击一级菜单
    clickFirstMenu(menu) {
      // 获取二级菜单
      this.$API.InterfaceConfigurationPage._getMenuList({
        params: {
          grade: 2,
          firstlevelid: menu.id
        }
      }).then(res => {
        if (res.success) {
          if (res.data == '[]') {
            this.secondMenuList = []
          } else {
            var n = 0
            if (res.data.length > 0) {
              res.data.forEach((otm, index) => {
                if (otm.type != 1 && n == 0) {
                  this.toDetail(otm)
                  n++
                }
              })
            }
          }
        } else {
          this.$Message.info('系统错误')
        }
      }).catch(err => {
        console.log('获取失败===', err);
      });
    },
    // 鼠标移入一级菜单
    mouseenterFirstMenu(menu, index) {
      this.firstMenu = menu
      // this.inputSearch = false
      // 获取二级菜单
      this.$API.InterfaceConfigurationPage._getMenuList({
        params: {
          grade: 2,
          firstlevelid: menu.id
        }
      }).then(res => {
        if (res.success) {
          this.currentMenuIndex = index
          if (res.data == '[]') {
            this.secondMenuList = []
          } else {
            // this.secondMenuList = res.data
            res.data.forEach(item => {
              item.threeMenuList = []
              if (item.pagemodel == 2 || item.pagemodel == 3) {
                var params = {
                  secondlevelid: item.id,
                  pagesize: 6,
                  pageindex: 1
                }
                // 查看文字列表
                this.$API.InterfaceConfigurationPage._getArticleList({
                  params
                }).then(res => {
                  if (res.success) {
                    item.threeMenuList = res.data
                  } else {
                    this.$Message.info('系统错误')
                  }
                }).catch(err => {
                  console.log('获取失败===', err);
                });
              }
            })
            this.secondMenuList = res.data
          }
        } else {
          this.$Message.info('系统错误')
        }
      }).catch(err => {
        console.log('获取失败===', err);
      });
    },
    // 获取菜单
    getMenulist() {
      this.$API.InterfaceConfigurationPage._getMenuList({
        params: {
          grade: 1
        }
      }).then(res => {
        if (res.success) {
          if (res.data == '[]') {
            this.menuList = []
          } else {
            this.menuList = res.data
          }
        } else {
          this.$Message.info('系统错误')
        }
      }).catch(err => {
        console.log('获取失败===', err);
      });
    },
    // 返回首页
    toHome() {
      this.$router.push({path: '/'})
    }
  }
}

</script>

<style scoped lang="less">
@import '../assets/css/header.less';

</style>



// WEBPACK FOOTER //
// src/components/headerTop.vue